import { render, staticRenderFns } from "./IconNotes.vue?vue&type=template&id=fc67d406"
import script from "./IconNotes.vue?vue&type=script&lang=ts"
export * from "./IconNotes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports